module.exports = __webpack_public_path__ + "static/img/fullscreen-image_hero_768.a2a29ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/training/fullscreen-image_hero_768.png
// module id = sEkG
// module chunks = 0